import {Button, Div, ImageView, Label} from 'components';
import {Ecolors, Icons, urlApp} from 'constant';
import React from 'react';
import {navigate} from 'services';
import {useAppSelector} from 'store/hooks';
import {convertAmount, copyToClipboard} from 'utils';
import QREventLink from './QREventLink';

const BorderCom = (p: {
  children: any;
  bordercolor?: any;
  isOpacity?: boolean;
}) => {
  return (
    <Div
      marginTop={14}
      borderRadius={10}
      borderWidth={0.8}
      borderColor={p.bordercolor || Ecolors.bordercolor}
      paddingVertical={9}
      opacity={p.isOpacity ? 0.5 : 1}
      paddingHorizontal={16}>
      {p.children}
    </Div>
  );
};

const RowSpace = (p: {
  title: string;
  content: string;
  isColor?: boolean;
  padding?: number;
  isCopy?: boolean;
  isBold?: boolean;
  textColor?: any;
}) => {
  return (
    <Div
      backgroundColor={p.isColor ? `#F5F5F5` : Ecolors.whiteColor}
      flexDirection="row"
      alignItems="center"
      padding={p.padding || 0}
      justifyContent="space-between"
      borderRadius={7}
      marginVertical={7}>
      <Div flex={1}>
        <Label size={14}>{p.title}</Label>
      </Div>
      <Div
        maxWidth={130}
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end">
        <Label
          numberOfLines={1}
          fontWeight={p.isBold ? 'bold' : '400'}
          size={14}
          color={p.textColor || Ecolors.textColor}
          multilanguage={false}>
          {p.content}
        </Label>
        {p.isCopy && (
          <Button
            onPress={() => {
              copyToClipboard(p.content);
            }}
            alignItems="center"
            flexDirection="row"
            widthHeight={30}
            justifyContent="flex-end">
            <ImageView
              source={Icons.copyevent}
              tintColor={Ecolors.mainColor}
              widthHeight={17}
              resizeMode="contain"
            />
          </Button>
        )}
      </Div>
    </Div>
  );
};

const ProgressCom = (p: {
  totalInvitedUserAdaptEvent: string;
  maximumInvitedUserAdaptEvent: string;
}) => {
  const width = 303;
  const size =
    (parseFloat(p.totalInvitedUserAdaptEvent) /
      parseFloat(p.maximumInvitedUserAdaptEvent)) *
    width;
  const height = 6;

  return (
    <Div
      marginVertical={7}
      height={height}
      borderRadius={height}
      borderColor={Ecolors.bordercolor}
      borderWidth={0.8}
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      overflow="hidden"
      width={width}>
      <Div
        width={size}
        height={height}
        borderRadius={height}
        backgroundColor={Ecolors.eventYellow}
      />
    </Div>
  );
};

const OverViewCom = () => {
  const walletBounty = useAppSelector(state => state.asset.walletBounty);
  const {
    myRefCode,
    remainBounty,
    totalBounty,
    totalInvitedUserAdaptEvent,
    usedBounty,
    maximumInvitedUserAdaptEvent,
    uploadFileStatus,
  } = walletBounty;
  const currentUser = useAppSelector(state => state.authen.currentUser);

  const eventLink = `${urlApp.eventLink}/register/sign-up?refCode=${myRefCode}`;
  return (
    <Div>
      <Label fontWeight="bold">{`eventreward.tongquan`}</Label>
      <BorderCom>
        <RowSpace
          title={`eventreward.tongtienthuongcuaban`}
          content={convertAmount(totalBounty || 0)}
          isBold={true}
        />
        <RowSpace
          title={`eventreward.tienthuongdasudung`}
          content={convertAmount(usedBounty || 0)}
        />
        <RowSpace
          title={`eventreward.sodutienthuong`}
          content={convertAmount(remainBounty || 0)}
        />
      </BorderCom>
      <BorderCom>
        <RowSpace
          title={`eventreward.soluongkhachhanggioithieuhople`}
          content={`${totalInvitedUserAdaptEvent || 0}`}
        />
        {/* <ProgressCom
          totalInvitedUserAdaptEvent={totalInvitedUserAdaptEvent || 0}
          maximumInvitedUserAdaptEvent={maximumInvitedUserAdaptEvent || 20}
        /> */}
      </BorderCom>
      {!!currentUser.eventRewardStandingOrder && (
        <BorderCom
          isOpacity={!uploadFileStatus}
          bordercolor={
            uploadFileStatus ? Ecolors.eventYellow : Ecolors.bordercolor
          }>
          <Button
            flexDirection="row"
            alignItems="center"
            paddingVertical={7}
            justifyContent="center"
            onPress={() => {
              if (!uploadFileStatus) {
                // Alert.showError({
                //   content: 'Chức năng hiện tại không hoạt động',
                //   multilanguage: false,
                // });
                return;
              }
              navigate('ImageTransactionModal');
            }}>
            <ImageView
              source={Icons.uploadevent}
              widthHeight={20}
              resizeMode="contain"
            />
            <Label
              marginLeft={10}
              size={14}>{`eventreward.uploadhinhanhgiaodich`}</Label>
          </Button>
        </BorderCom>
      )}
      <BorderCom>
        <RowSpace
          title="eventreward.magioithieu"
          content={myRefCode}
          padding={11}
          isColor={true}
          isCopy={true}
          textColor={Ecolors.linkColor}
        />
        <RowSpace
          isColor={true}
          padding={11}
          title="eventreward.linkgioithieu"
          content={eventLink}
          isCopy={true}
          textColor={Ecolors.linkColor}
        />
        <QREventLink eventLink={eventLink} />
        {/* <Button
          width={303}
          height={48}
          marginTop={11}
          onPress={() => {
            // share link https://daiichi.dev.techland.link/register/sign-up?refCode=RI0987589030
            ShareContent({
              message: eventLink,
              // url: eventLink,
            });
          }}
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          borderRadius={5}
          backgroundColor={Ecolors.mainColor}>
          <ImageView
            widthHeight={17}
            marginRight={5}
            resizeMode="contain"
            source={Icons.eventshare}
            tintColor={Ecolors.whiteColor}
          />
          <Label
            color={Ecolors.whiteColor}
            size={14}
            fontWeight="bold">{`eventreward.chiaselienket`}</Label>
        </Button> */}
        <Button
          alignItems="center"
          justifyContent="center"
          onPress={() => {
            navigate('IntroductionModal');
          }}
          paddingVertical={14}>
          <Label
            color={Ecolors.linkColor}
            size={14}>{`eventreward.xemhuongdanchitiet`}</Label>
        </Button>
      </BorderCom>
    </Div>
  );
};

export default React.memo(OverViewCom);
